export default "__VITE_ASSET__DnJ9vxN5__"